import { render, staticRenderFns } from "./painelTecnicos.vue?vue&type=template&id=14cad348&scoped=true"
import script from "./painelTecnicos.vue?vue&type=script&lang=js"
export * from "./painelTecnicos.vue?vue&type=script&lang=js"
import style0 from "./painelTecnicos.vue?vue&type=style&index=0&id=14cad348&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cad348",
  null
  
)

export default component.exports